import { createActions } from '../helpers/redux';

export const AppActions = createActions({
  globalResetReducers() {
    return {};
  },

  dismissNotices(payload) {
    return {
      notificationType: payload.type,
      notificationIdx: payload.notificationIdx
    };
  },

  hideNotification() {
    return {};
  },

  setNotification(notification) {
    return { notification };
  },

  setIEBool(bool) {
    return {
      bool,
    }
  }
});



// WEBPACK FOOTER //
// ./src/actions/app.js